import styled from 'styled-components/macro';

const SpellingDialogItemStyled = styled.div`
  padding: 5px 10px;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    background: #1a1616;
    color: #fff;
  }
`;

export default SpellingDialogItemStyled;
